export const PrintQuoteItemType = {
    PART: 'PART',
    KIT_SUMMARY: 'KIT_SUMMARY',
    WARNING: 'WARNING',
};

export const QuoteItemTypes = {
    LABOR: 'LABOR',
    OTHER: 'OTHER',
};

export const PaymentMethod = {
    CASH_ON_DEMAND: 'COD',
};

export const prop65URL = 'www.p65warnings.ca.gov';

export const MaxFieldLength = {
    GARAGE_BAY_ID: 4,
    FLEET_ID: 10,
    PO_NUMBER: 22,
};
